import comp from "./Cards";
export default comp;
